import * as Yup from 'yup';
import { REQUIRED_FIELD, phoneNumberRegex } from 'Constants';

const validationSchema = () => Yup.object({
  phoneNumber: Yup.string().required(REQUIRED_FIELD).matches(phoneNumberRegex, 'Phone number is not valid'),
  // phoneNumberVerificationCode: Yup.string().trim().required(REQUIRED_FIELD),
});

export default validationSchema;